<template>
  <div class="default-layout">
    <Head>
      <Link rel="canonical" :href="useRuntimeConfig().public.websiteUrl + ( $route.path?.slice(-1) === '/' ? $route.path?.substring(0, $route.path?.length - 1) : $route.path)" />
    </Head>
    <LayoutTheHeader />
    <slot class="default-layout-content" :keep-alive="isKeepAlive" :keep-alive-props="{ max: 5, include: includedComponents, exclude: excludedComponents }" />
    <LayoutTheFooter />
    <SharedCookieBanner />
  </div>
</template>

<script>

export default {
  data () {
    return {
      includedComponents: ['CommunityHome', 'HelpSearchResult'],
      excludedComponents: [],
      hasKeepAlive: false
    }
  },
  computed: {
    isKeepAlive () {
      return this.hasKeepAlive
    }
  },
  watch: {
    $route () {
      if (this.hasKeepAlive !== this.$route.meta.keepAlive) { this.hasKeepAlive = this.$route.meta.keepAlive }
    }
  },
  mounted () {
    this.hasKeepAlive = this.$route.meta.keepAlive
  }
}
</script>

  <style lang="postcss" scoped>
  .default-layout {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .default-layout-content {
      flex-grow: 1;
    }
  }
  </style>

  <style>
  *,
  *:before,
  *:after {
    box-sizing: border-box;
    margin: 0;
  }
  </style>
